import Product from '../product';
import { ProductTypes } from '../product-type';
import IPBoardPart from './ip-board-part';
import ExtraBoard from './extra-board';
import { PoleColor } from '../../sign/enums/pole-color';
import { IPBoardRegisteredAction } from './ip-board-registered-action';

export default class IPBoard extends Product {
  boardPart?: IPBoardPart;
  otherSideBoardPart?: IPBoardPart;

  extraBoard?: ExtraBoard;
  extraBoardText?: string;
  extraBoardColor?: string;
  poleColor?: PoleColor;
  draftDesign?: boolean;

  leftRightBoard?: boolean;

  registeredActions?: IPBoardRegisteredAction[];

  constructor() {
    super();
    this.type = ProductTypes.IP_BOARD.value;
  }

  // Override
  public canSubmitAsClient(): boolean {
    return true; // TODO implement
  }
}
